import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Autoplay } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="big_numbers"]');

class Big_numbers {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const swiperComponent = component.querySelector('.swiper');
            if (swiperComponent) this.initSwiper(swiperComponent);
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Navigation, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 40,
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    }
}

(() => {
    if (MODULE) {
        new Big_numbers();
    }
})();

export default Big_numbers;
